import { coverAmount } from "../domain/cover";
import { ProgressBar } from "./ProgressBar";

export interface CoverBarRow {
  key: string;
  label: string;
  unit: "g" | "mg";
  /** the share of the need, 0–1 (a portion may pass 1); null when not known */
  share: number | null;
  amount: number | null;
  target: number | null;
}

/**
 * The share of each need covered (SNIPPETS §30): one kit ProgressBar per nutrient under a caption,
 * the full bar being the need. Every fill is brand — no target tick and no verdict colour, because
 * nothing here is over or good. Limits never get a bar; they go in a sentence below. A nutrient
 * not known says so and draws an empty track (invariant 11).
 */
export function CoverBars({ rows, caption }: { rows: CoverBarRow[]; caption: string }) {
  return (
    <div className="k-cover">
      <p className="k-cover__cap">{caption}</p>
      {rows.map((r) => {
        const pct = r.share === null ? null : Math.round(r.share * 100);
        const of =
          r.amount !== null && r.target !== null ? `${coverAmount(r.amount)} of ${coverAmount(r.target)} ${r.unit}` : null;
        return (
          <ProgressBar
            key={r.key}
            value={pct}
            max={100}
            label={r.label}
            detail={
              pct === null ? (
                "not known"
              ) : (
                <>
                  <span className="k-cover__pct">{pct} %</span>
                  {of ? ` · ${of}` : null}
                </>
              )
            }
            ariaLabel={pct === null ? `${r.label}: not known` : `${r.label} ${pct} percent covered${of ? `, ${of}` : ""}`}
          />
        );
      })}
    </div>
  );
}
